import * as React from "react";


const columns = (t) => [

    {
        label: t ? t("common.name") : "Nazwa",
        field: "name",
        width: 53,

    },

]

export default columns;